module.exports = __webpack_public_path__ + "static/img/f1.af0ce98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/center/precision/f1.png
// module id = ayHV
// module chunks = 0